<template>
  <div class="am-slider-container">
    <swiper class="swiper-container" ref="mySwiper" :options="swiperOptions">

        <!-- <swiper-slide class="swiper-slider" :data-swiper-autoplay="duration + '000'">
            <div class="slide-card" :style="{backgroundImage: `url(${require('../../assets/ami/header.png')})`}">
                <div class="slide-widget" :style="{backgroundColor: `${'#0020A5'}`}">
                    <div class="sub-title">Accreditation</div>
                    <div class="sub-title-line" :style="{backgroundColor: `${'#26CBBE'}`}"></div>
                    <div class="us-bg-title" v-html="'Become  An Accredited <br /> Training Center'"></div>
                    <div class="text" v-html="' American Management Institute   (AMI) is One of the world’s <br /> premier professional studies and research institutions, (AMI)<br /> has driven new ways of thinking since our 1998 founding. '"></div>
                    <router-link to="/" class="us-btn">Explore</router-link>
                    <div class="box-bg-color" :style="{backgroundColor: `${'#00B1FF'}`}"></div>
                </div>
            </div>
        </swiper-slide> -->

        <swiper-slide v-for="(row, index) in rows" :key="index" class="swiper-slider" :data-swiper-autoplay="row.duration + '000'">
            <div class="slide-card" :style="{backgroundImage: `url(${row.file})`}">
                <div class="slide-widget" :style="{backgroundColor: `${row.bgColor} !important`}">
                    <div class="sub-title" v-html="row.title"></div>
                    <div class="sub-title-line" :style="{backgroundColor: `${row.lineColor} !important`}"></div>
                    <div class="us-bg-title" v-html="row.subTitle"></div>
                    <div class="text" v-html="row.body"></div>
                    <router-link v-if="row.button" :to="row.redirect" class="us-btn" v-html="row.button"></router-link>
                    <div class="box-bg-color" :style="{backgroundColor: `${row.boxColor}`}"></div>
                </div>
            </div>
        </swiper-slide>

    </swiper>
    <div class="swiper-pagination" slot="pagination"></div>
  </div>
</template>

<style scoped>
.am-slider-container {
    height: calc(100vh - 84.21px);
    min-height: 638.19px;
    position: relative;
}
.swiper-container {
    height: 100%;
}
.slide-card {
    background-size: cover;
    /* background-position: center; */
    position: relative;
    height: 100%;
}
.slide-widget {
    padding: 40px; 
    position: absolute;
    bottom: 50px;
    left: 50px;
    width: auto;
    display: inline-block;
}
.box-bg-color {
    width: 40px;
    height: 40px;
    position: absolute;
    bottom: 0;
    right: 0;
}
.sub-title {
    font-weight: 500;
    color: #fff;
    font-size: 18px;
    margin-bottom: 8px;
}
.sub-title-line {
    width: 120px;
    height: 5px;
    margin-bottom: 13px;
}
.us-bg-title {
    font-size: 37px;
    color: #fff;
    font-weight: bold;
    line-height: 1;
    margin-bottom: 16px;
}
.text {
    color: #fff;
    font-size: 17px;
    line-height: 1.4;
    margin-bottom: 22px;
}
.us-btn {
    border: 1px solid #fff;
    color: #fff;
    padding: 2px 23px;
    display: inline-block;
    font-size: 18px;
}
.us-btn:hover {
    background: #fff;
    color: #000;
}
.us-btn:active {
    opacity: 0.6;
}
.swiper-pagination {
    display: flex;
    justify-content: center;
    width: auto;
    display: inline-block;
    position: absolute;
    right: 50px;
    bottom: 50px;
    line-height: 1;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
    .text {
        font-size: 15px;
    }
    .slide-widget {
        padding: 30px 25px;
        bottom: 80px;
        left: 15px;
        width: calc(100% - 30px);
    }
    .us-bg-title {
        font-size: 30px;
    }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
    .slide-widget {
        width: auto;
    }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {

}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
// Very Important npm install swiper@5.4.5 
import axios from 'axios';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: "Slider",
//   props: ['row'],
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  
  data() {
    return {
      pgLoading: true,
      duration: 4,
      rows: [],
      swiperOptions: {
        loop: false,
        speed: 800,
        autoplay: {
            
          // delay: 4000, or data-swiper-autoplay="2000" in html
        },
        spaceBetween: 10,
        // slidesPerView: 3,
        navigation: {
            nextEl: '.swiperNext',
            prevEl: '.swiperPrev'
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets"
        },
      }
    };
  },
  created() {
    this.fetchSlider();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  methods: {
    prev() {
        this.$refs.mySwiper.$swiper.slidePrev();
    },
    next() {
        this.$refs.mySwiper.$swiper.slideNext();
    },
    fetchSlider() {
      axios
        .get(window.baseURL + "/sliders")
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;
        })
        .catch(() => {});
    },
  },
};
</script>
